import { motion } from "framer-motion";

export const HeroSection = () => {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-[#F5F5F7] to-white" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="apple-heading text-4xl sm:text-5xl lg:text-6xl mb-6 tracking-tight">
            Transforming Memory Care
          </h1>
          <p className="apple-subheading text-lg sm:text-xl lg:text-2xl max-w-3xl mx-auto text-[#86868b]">
            Discover how our <span className="ai-term">vertical AI</span> and <span className="ai-term">guided-agentic AI</span> technologies 
            are revolutionizing cognitive health monitoring and support.
          </p>
        </motion.div>
      </div>
    </section>
  );
};